const AMPLITUDE_API_KEY = import.meta.env.PUBLIC_AMPLITUDE_API_KEY || "85ca3c2b711d185aa7fc1f5047506d34";
export {AMPLITUDE_API_KEY}

const TRUSTPILOT_SCORE_SHOW_THRESHOLD = 4;
export {TRUSTPILOT_SCORE_SHOW_THRESHOLD};